/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ThreadMetadata } from "./ThreadMetadata";
import { ThreadState } from "./ThreadState";
import { ThreadStatus } from "./ThreadStatus";
import { StateUpdateStrategy } from "./StateUpdateStrategy";
export const ThreadApiUpdateData = core.serialization.object({
    resourceId: core.serialization.string().optional(),
    metadata: ThreadMetadata.optional(),
    source: core.serialization.string().optional(),
    state: ThreadState.optional(),
    status: ThreadStatus.optional(),
    stateUpdateStrategy: StateUpdateStrategy.optional(),
});
